module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6ppwu"))).then(() => parcelRequire('3a9aZ'));